import React from 'react';
import styles from './Card.module.css';
import Card from './Card';
import CardComing from "./CardComing";
import CardRating from "./CardRating";
import loginForm from "../Login/LoginForm";
import CardSimple from "./CardSimple";
import {afficherRating} from "../../services/SeanceService";

const CardGridSmart = ({ cards }) => {
    const getCardComponent = (card) => {
        if (card.status === 1){
            return <CardComing key={card.id} {...card} />;
        } else if (afficherRating(card)){
            return <CardRating key={card.id} {...card} />;
        } else  {
            return <CardSimple key={card.id} {...card} />;
        }

        return null;
    };

    return (
        <div className={styles.cardGrid}>
            {cards.map(card => getCardComponent(card))}
        </div>
    );
};

export default CardGridSmart;
